import React from 'react';

// DO NOT EDIT - THIS FILE IS GENERATED
/* eslint-disable */

var yogaMatIcon = /*#__PURE__*/React.createElement("svg", {
  height: "24",
  width: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("path", {
  d: "M4.089 2.077a4.855 4.855 0 0 1 5.52 4.038h13.624A.777.777 0 0 1 24 6.88v14.33a.777.777 0 0 1-.767.767H5.878C2.628 21.978 0 19.31 0 15.222V7.045a4.978 4.978 0 0 1 4.09-4.968Zm18.378 5.57H9.69v8.433a3.332 3.332 0 0 1-3.322 3.322 3.22 3.22 0 0 1-3.28-3.23c0-1.129.915-2.044 2.044-2.044.144.001.288.018.429.051.828.184 1.206 1.319.572 1.748-.174.123-.45.286-.45.286a.552.552 0 0 0-1.103 0 1.687 1.687 0 0 0 1.788 1.656 1.799 1.799 0 0 0 1.79-1.789 3.322 3.322 0 1 0-6.645 0 4.354 4.354 0 0 0 4.344 4.344h16.61V7.648ZM4.835 3.56a3.322 3.322 0 0 0-3.322 3.322v5.663a4.845 4.845 0 0 1 6.644 0V6.88a3.322 3.322 0 0 0-3.322-3.32Z",
  fill: "currentColor",
  fillRule: "evenodd"
}));

export { yogaMatIcon as default };
//# sourceMappingURL=yogaMatIcon.js.map
